import {
  IApplyOptionsCommonSearchParam,
  IConflictTableReport,
} from "src/Interfaces/applyOption";
import { getConflictTable } from "src/Requests/applyOption";
import { CommonTableUI } from "../../TableTemplate/common";
import TableTemplate from "../../TableTemplate/tableTemplate";
import { Additional } from "./Additional";

interface IProps {
  searchParams: IApplyOptionsCommonSearchParam;
  refreshFlag?: boolean;
}

const ConflictTable = ({ searchParams, refreshFlag }: IProps) => {
  return (
    <TableTemplate<IApplyOptionsCommonSearchParam, IConflictTableReport>
      TableUI={({ reports, onAction, setSortingType, sortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          setSortingType={setSortingType}
          sortingType={sortingType}
          tableBoxClassName="max-h-[500px] overflow-auto"
           AdditionalBody={Additional}
          refreshFlag={refreshFlag}
        />
      )}
      getDataTable={getConflictTable}
      searchParameters={searchParams}
      pagesize={200}
      withSort
    />
  );
};

export default ConflictTable;
